<template>
    <el-dialog
        title="添加作业"
        :visible.sync="visible"
        width="7.7rem"
        class="step-audit-dialog"
        key="job"
        :before-close="handleJobDialogClose">
        <el-form :model="form" :rules="rules" ref="jobDialogForm" label-width="133px" :inline="true" key="5" class="user-step-split-form">
            <el-form-item label="作业名称：" class="form-left-item" prop="workName">
                <el-input v-model="form.workName" placeholder="请输入作业名称"></el-input>
            </el-form-item>
            <el-form-item label="作业起止时间：" class="form-left-item" prop="timeRange">
                <el-date-picker
                    v-model="form.timeRange"
                    type="daterange"
                        placeholder="请选择作业起止时间"
                    class="job-time-item"
                    range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="作业说明：" class="form-left-item" prop="workDesc">
                <el-input type="textarea" v-model="form.workDesc" placeholder="请输入作业说明"></el-input>
            </el-form-item>
            <el-form-item label="上传附件：" class="form-left-item">
                <el-button size="mini"><oosUpload
                    ref="oosRefUpload"
                    uploadSoltType="text"
                    uploadSoltText="上传附件"
                    :value.sync="fileList"
                    :showFileList="false"
                    @on-sucess="onUploadSucess"
                    :folder="'user'"
                    accept="image/*,video/mp4,vedio/mp4,audio/mp4,application/pdf"
                    class="user-setting-img"
                ></oosUpload></el-button>
            </el-form-item>
        </el-form>
        <div class="training-step-table">
            <el-table :data="form.workFiles" style="width: 100%" key="jobtable">
                <el-table-column type="index" label="序号" width="100"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="fileType" label="类型"></el-table-column>
                <el-table-column prop="date" label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="table-btn table-btn-view" @click="viewJobItem(scope.row)">
                            <i class="el-icon-view"></i>
                            <span>查看</span>
                        </div>
                        <div class="table-btn table-btn-delete" @click="deleteJobItem(scope.$index)">
                            <i class="el-icon-delete"></i>
                            <span>删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleJobDialogSave('jobDialogForm')">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import oosUpload from '@/components/oosUpload/index.vue'
export default {
    name: 'job-dailog',
    components: { oosUpload },
    props: ['visible'],
    data() {
        return {
            form: {
                workName: '',
                workDesc: '',
                timeRange: [],
                workFiles: []
            },
            rules: {
                workName: [
                    { required: true, message: '请输入作业名称', trigger: 'change' },
                ],
                timeRange: [
                    { required: true, message: '请输入作业起止时间段', trigger: 'change' },
                ]
            },
            fileList: []
        }
    },
    methods: {
        // 弹窗-作业保存
        handleJobDialogSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('confirmDailog', this.form)
                    this.handleJobDialogClose()
                } else {
                    return false;
                }
            });
        },
        // 弹窗-作业关闭
        handleJobDialogClose() {
            this.$emit('closeDailog')
        },
        onUploadSucess() {
            this.form.workFiles = this.form.workFiles.concat(JSON.parse(JSON.stringify(this.fileList)))
            this.fileList = []
        },
        deleteJobItem(index) {
            this.form.workFiles.splice(index, 1)
        },
        viewJobItem(row) {
            window.open(window.wtConst.OSS + row.url)
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.form.workFiles = []
                this.$nextTick(() => {
                    this.$refs.jobDialogForm.resetFields()
                })
            }
        }
    }
}
</script>

<style>

</style>